import {KTIcon} from '../../../_metronic/helpers'
import {useAuth2} from '../authv2/Auth2Provider'
import {CompanySelectorFormWrapper} from './CompanySelectorFormWrapper'

const CompanySelectorModal = () => {
  const {
    userData,
    isCompanySelectorModalOpen,
    setCompanySelectorModalStatus,
    selectedCompanyId,
    selectedRole,
  } = useAuth2()

  const onClose = () => {
    setCompanySelectorModalStatus(false)
  }

  const isDisabled = selectedCompanyId === '' || selectedRole === ''

  return (
    <>
      {isCompanySelectorModalOpen && (
        <>
          <div>
            <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
              <div className='modal-dialog modal-xl modal-dialog-centered mw-400px'>
                <div className='modal-content'>
                  {/* <CompanySelectorModalHeader /> */}
                  <div className='modal-body scroll-y mx-5 mx-xl-5 my-2'>
                    <div className='w-100 d-flex justify-content-end align-items-center'>
                      <button
                        onClick={() => onClose()}
                        disabled={isDisabled}
                        className='btn btn-icon btn-sm btn-active-light-primary'
                      >
                        <KTIcon iconName='cross' className='fs-1 text-muted' />
                      </button>
                    </div>
                    <CompanySelectorFormWrapper userData={userData} onClose={() => onClose()} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='modal-backdrop fade show'></div>
        </>
      )}
    </>
  )
}

export {CompanySelectorModal}
